export default "__VITE_ASSET__f902573a__"